var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApartmentsAlt9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9C6 7.89543 6.89543 7 8 7H16C17.1046 7 18 7.89543 18 9V21C18 21.5523 17.5523 22 17 22H15V19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19V22H7C6.44772 22 6 21.5523 6 21V9ZM8.75 10C8.75 10.4142 9.08579 10.75 9.5 10.75H14.5C14.9142 10.75 15.25 10.4142 15.25 10C15.25 9.58579 14.9142 9.25 14.5 9.25H9.5C9.08579 9.25 8.75 9.58579 8.75 10ZM8.75 13C8.75 13.4142 9.08579 13.75 9.5 13.75H14.5C14.9142 13.75 15.25 13.4142 15.25 13C15.25 12.5858 14.9142 12.25 14.5 12.25H9.5C9.08579 12.25 8.75 12.5858 8.75 13Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H4.70802C4.57422 21.6938 4.5 21.3556 4.5 21V9C4.5 7.067 6.067 5.5 8 5.5H11V4C11 2.89543 10.1046 2 9 2H4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.292 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H15C13.8954 2 13 2.89543 13 4V5.5H16C17.933 5.5 19.5 7.067 19.5 9V21C19.5 21.3556 19.4258 21.6938 19.292 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentsAlt9);
export default __webpack_public_path__ + "static/media/apartments-alt-9.b454f526e95aea81f30d58020aa4d498.svg";
export { ForwardRef as ReactComponent };